// src/utils/mediaType.js
// Hero / gallery items are stored as plain URLs. Videos are MP4 only, so a URL pointing at an
// .mp4 file (Firebase Storage download links keep the extension before "?alt=media") is a video.

export const isVideoUrl = (url) => typeof url === 'string' && /\.mp4(?:[?#]|$)/i.test(url);

// Other video formats are rejected up front because they don't play on every browser
export const isUnsupportedVideoUrl = (url) =>
  typeof url === 'string' && /\.(?:mov|webm|avi|mkv|wmv|flv|m4v|3gp)(?:[?#]|$)/i.test(url);
